import { FC, useState } from 'react';
import EditorVideo from 'lowcode/components/EditorVideo';
import EditorImg from 'lowcode/components/EditorImg';
import css from './index.module.scss';
import IconArrow from './IconArrow';
import { useLang } from '@/i18n';

const TheComp: FC = () => {
    const { t } = useLang('dp3.landing.ConnectHome');
    const [hoverIndexA, setHoverIndexA] = useState<number>(1);
    const [hoverIndexB, setHoverIndexB] = useState<number>(1);

    // 悬浮事件-1层
    const handleHoverA = (index: number) => {
        setHoverIndexA(index);
        if (index === 1) {
            const elem: any = document.querySelector('#ConnectHome-id2 .comp-video-box video');
            if (elem && elem.play) {
                elem.play();
            }
        }
    };
    // 悬浮事件-2层
    const handleHoverB = (index: number) => {
        setHoverIndexB(index);
    };
    return (
        <div className={`${css.thecomp} GtmModuleData-section`} data-section-id={'dp3-ConnectHome'} data-section-title={t('title')} id="ConnectHome-id2">
            <div className="comp-module">
                <div className="comp-module-l">
                    <div className="dp3-title">{t('title')}</div>
                    <div
                        className={`lista-box lista-box-1${hoverIndexA === 1 ? ' comp-hover' : ''}`}
                        onClick={() => {
                            handleHoverA(1);
                        }}
                    >
                        <div className="lista-title comp-sub-title">
                            {t('item1_title')}
                            <IconArrow />
                        </div>
                        <div className="comp-video-box">
                            <EditorVideo pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/video/1718709891957/v1.mp4" autoPlay={true} loop={true} />
                            <EditorImg
                                pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718875833780/app1.jpg"
                                className="comp-sub-a comp-sub-a-2"
                            />
                            <EditorImg
                                pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718875860625/app2.jpg"
                                className="comp-sub-a comp-sub-a-3"
                            />
                        </div>
                        <div className="lista-desc-box">
                            <div
                                className={`listc-box listc-box-1${hoverIndexB === 1 ? ' hover' : ''}`}
                                onClick={() => {
                                    handleHoverB(1);
                                }}
                            >
                                <div className="listc-title">{t('item1_label1_title')}</div>
                                <div className="listc-desc comp-sub-desc">{t('item1_label1_desc')}</div>
                            </div>
                            <div
                                className={`listc-box listc-box-2${hoverIndexB === 2 ? ' hover' : ''}`}
                                onClick={() => {
                                    handleHoverB(2);
                                }}
                            >
                                <div className="listc-title">{t('item1_label2_title')}</div>
                                <div className="listc-desc comp-sub-desc">{t('item1_label2_desc')}</div>
                            </div>
                            <div
                                className={`listc-box listc-box-3${hoverIndexB === 3 ? ' hover' : ''}`}
                                onClick={() => {
                                    handleHoverB(3);
                                }}
                            >
                                <div className="listc-title">{t('item1_label3_title')}</div>
                                <div className="listc-desc comp-sub-desc">{t('item1_label3_desc')}</div>
                            </div>
                        </div>
                    </div>
                    <div
                        className={`listb-box${hoverIndexA === 2 ? ' comp-hover' : ''}`}
                        onClick={() => {
                            handleHoverA(2);
                        }}
                    >
                        <div className="listb-title comp-sub-title">
                            {t('item2_title')}
                            <IconArrow />
                        </div>
                        <div className="comp-video-box">
                            <EditorImg pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718886436372/a1.jpg" />
                        </div>
                        <div className="listb-desc comp-sub-desc">{t('item2_desc')}</div>
                    </div>
                    <div
                        className={`listb-box${hoverIndexA === 3 ? ' comp-hover' : ''}`}
                        onClick={() => {
                            handleHoverA(3);
                        }}
                    >
                        <div className="listb-title comp-sub-title">
                            {t('item3_title')}
                            <IconArrow />
                        </div>
                        <div className="comp-video-box">
                            <EditorImg pc="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719217603410/a33.jpg" />
                        </div>
                        <div className="listb-desc comp-sub-desc">{t('item3_desc')}</div>
                    </div>
                </div>
                <div className="comp-module-r"></div>
            </div>
        </div>
    );
};

export default TheComp;
